import { State } from '../@types';

export const selectCarCheckImages = (store: State) =>
  store.camera.carCheckImages;
export const selectCameraImages = (store: State) => store.camera.images;
